import { useState } from "react";
import { BudgetTableContext, EntryDialogState } from "./types";

export const BudgetTableContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [entryDialog, setEntryDialog] = useState<EntryDialogState>({ open: false });

  return (
    <BudgetTableContext.Provider value={{
      entryDialog,
      setEntryDialog,
      allowAddingExpenseToQuote: true,
    }}>
      {children}
    </BudgetTableContext.Provider>
  );
};

